module.exports = __webpack_public_path__ + "img/CyberReadinessCheckMobile.b9938f6a.png";